import { Route, BrowserRouter as Router, Switch, Link } from "react-router-dom";
import Footer from "./Footer";

const Layout = props => {
  return (
    <div className="container-fluid">
      <div
        className="About"
        style={{ backgroundImage: "url(/images/background.png)" }}
      >
        <h2 className='p-5'>Choose your category</h2>
        {props.children}
        <Footer />
      </div>
    </div>
  );
};

export default Layout;
